import DNDFileUpload from './DNDFileUpload';

export default DNDFileUpload;